<app-view-title Title="" [isSoftSplit]="true"></app-view-title>
<view-content [centered]="true" [fullscreen]="true">

  <app-card>
    <h2>{{ 'Intellitrailer.Rental.ConfirmLock.Confirm' | translate : 'Confirm' }}</h2>
    <p>
      {{ 'Intellitrailer.Rental.ConfirmLock.ReturnProccessInfo' | translate : 'To complete the return process you must return the trailer to the return location and lock it using the provided cover and padlock.' }}
    </p>
    <h2>{{ 'Intellitrailer.Rental.ConfirmLock.Headline' | translate : 'Did you lock the trailer?' }}</h2>
    <div class="row">
      <div class="col-6">
        <button mat-raised-button color="accent" (click)="cmdYes_Click()">{{ 'Intellitrailer.Rental.ConfirmLock.cmdYes' | translate : 'Yes' }}</button>
      </div>
      <div class="col-6">
        <button mat-raised-button color="accent" (click)="cmdNo_Click()">{{ 'Intellitrailer.Rental.ConfirmLock.cmdNo' | translate : 'No' }}</button>
      </div>
    </div>
  </app-card>

</view-content>

